import * as React from 'react';
import styled from '@emotion/styled';

interface PropsType {
    className?: string;
    fill?: string;
}

const SvgElement = styled('svg', { label: 'SvgElement' })<PropsType>`
    height: auto;
`;

export const YaspaCard = ({ className }: PropsType): JSX.Element => (
    <SvgElement
        className={className}
        width={32}
        height={20}
        viewBox='0 0 32 20'
        fill='none'
    >
        <path
            d='M0 2C0 0.895431 0.895431 0 2 0H30C31.1046 0 32 0.895431 32 2V18C32 19.1046 31.1046 20 30 20H2C0.895431 20 0 19.1046 0 18V2Z'
            fill='white'
        />
        <path
            d='M2 0.5H30C30.8284 0.5 31.5 1.17157 31.5 2V18C31.5 18.8284 30.8284 19.5 30 19.5H2C1.17157 19.5 0.5 18.8284 0.5 18V2C0.5 1.17157 1.17157 0.5 2 0.5Z'
            stroke='#101D3A'
            strokeOpacity='0.1'
        />
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M13.1924 7.57039H13.741C13.801 7.57039 13.8476 7.61925 13.8476 7.67699V11.1504C13.8476 11.2126 13.7965 11.2636 13.7343 11.2636H13.1924C13.1258 11.2636 13.0881 11.2192 13.0881 11.1504L13.0725 10.6596C12.8082 11.0882 12.3707 11.3525 11.7689 11.3525C10.714 11.3525 9.99 10.5086 9.99 9.41591C9.99 8.32326 10.714 7.47934 11.7689 7.47934C12.3796 7.47934 12.8171 7.7525 13.0725 8.18112L13.0881 7.68366C13.0881 7.61481 13.1236 7.57039 13.1924 7.57039ZM10.7806 9.41591C10.7806 10.131 11.2625 10.6063 11.9266 10.6063V10.6085C12.5817 10.6085 13.0414 10.1421 13.0414 9.42479C13.0414 8.70746 12.5906 8.22554 11.9266 8.22554C11.2625 8.22554 10.7806 8.7008 10.7806 9.41591Z'
            fill='black'
        />
        <path
            d='M15.8686 9.01172L16.3127 9.19161L16.3172 9.19605C16.7902 9.3826 17.1677 9.69352 17.1677 10.2576C17.1589 10.9794 16.5415 11.3569 15.833 11.3569C15.229 11.3569 14.7914 11.0771 14.5361 10.7684C14.4894 10.7151 14.4894 10.6396 14.5427 10.5641L14.7381 10.2931C14.7892 10.2176 14.8581 10.2243 14.918 10.2776C15.1912 10.5108 15.4621 10.6618 15.793 10.6618C16.1239 10.6618 16.3571 10.5263 16.3571 10.2332C16.3571 9.97778 16.1839 9.85786 15.8819 9.72905L15.4288 9.54916C14.9625 9.36039 14.6071 9.05836 14.6071 8.53868C14.6071 7.87465 15.1734 7.48379 15.8286 7.48379C16.2816 7.48379 16.7036 7.67256 16.9901 8.02567C17.0367 8.07897 17.0278 8.13893 16.9834 8.18335L16.7502 8.46317C16.6903 8.53202 16.6392 8.52314 16.5703 8.46317C16.3349 8.24331 16.1106 8.13893 15.8686 8.13893C15.5821 8.13893 15.3866 8.2744 15.3866 8.5298C15.3866 8.7852 15.5821 8.89846 15.8686 9.01172Z'
            fill='black'
        />
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M19.8971 7.47934C19.2864 7.47934 18.8489 7.75028 18.5935 8.18112L18.578 7.68366C18.578 7.61481 18.5402 7.57039 18.4736 7.57039H17.9317C17.8695 7.57039 17.8184 7.62147 17.8184 7.68366V12.414C17.8184 12.4718 17.8651 12.5206 17.925 12.5206H18.5202C18.5824 12.5206 18.6335 12.4696 18.6335 12.4074V10.7151C18.8978 11.1148 19.3264 11.3547 19.8994 11.3547C20.9543 11.3547 21.6783 10.5174 21.6783 9.41813C21.6783 8.31882 20.9543 7.48156 19.8994 7.48156L19.8971 7.47934ZM19.7395 10.6063C19.0843 10.6063 18.6246 10.131 18.6246 9.42257C18.6246 8.71412 19.0843 8.22332 19.7395 8.22332C20.3946 8.22332 20.8854 8.70524 20.8854 9.41369C20.8854 10.1221 20.4035 10.6041 19.7395 10.6041V10.6063Z'
            fill='black'
        />
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M25.3426 7.57039H25.8934V7.56817C25.9534 7.56817 26 7.61703 26 7.67477V11.157C26 11.217 25.9511 11.2636 25.8934 11.2636H25.3426C25.276 11.2636 25.2383 11.2192 25.2383 11.1504L25.2227 10.6596C24.9584 11.0882 24.5209 11.3525 23.9191 11.3525C22.8642 11.3525 22.1402 10.5086 22.1402 9.41591C22.1402 8.32326 22.8642 7.47934 23.9191 7.47934C24.5298 7.47934 24.9673 7.7525 25.2227 8.18112L25.2383 7.68366C25.2383 7.61481 25.2738 7.57039 25.3426 7.57039ZM22.9308 9.41591C22.9308 10.131 23.4127 10.6063 24.0768 10.6063V10.6085C24.7319 10.6085 25.1916 10.1421 25.1916 9.42479C25.1916 8.70746 24.7408 8.22554 24.0768 8.22554C23.4127 8.22554 22.9308 8.7008 22.9308 9.41591Z'
            fill='black'
        />
        <path
            d='M9.20161 7.48824C8.79742 7.42605 8.45319 7.77028 8.51537 8.17447C8.55312 8.42765 8.75966 8.63197 9.01284 8.67194C9.41703 8.73413 9.76126 8.38989 9.69908 7.9857C9.66132 7.73253 9.45479 7.52821 9.20161 7.48824Z'
            fill='black'
        />
        <path
            d='M6.92303 7.5704C6.96967 7.5704 7.01409 7.59261 7.04296 7.62814L8.5931 9.52251C8.83961 9.82455 8.83961 10.2643 8.5931 10.5663L7.04296 12.4607C7.01409 12.4984 6.96967 12.5184 6.92303 12.5184H6.05247C6.00805 12.5184 5.98362 12.4673 6.01249 12.4318L7.95794 10.0666C7.96905 10.0533 7.96905 10.0355 7.95794 10.0222L6.01249 7.65701C5.98362 7.62148 6.00805 7.5704 6.05247 7.5704H6.92303Z'
            fill='black'
        />
    </SvgElement>
);
